const StatTableType = Object.freeze({
    SERVICES: 'Services',
    SUBSCRIPTION: 'Subscription',
    CONSULTING: 'Consulting',
    OTHER: 'Other',
});
export default StatTableType;
